import { dynamic_page_messages } from '@@constants/dynamic-page-messages'
import { Component, OnInit, Input } from '@angular/core'
import { ActivatedRoute } from '@angular/router'

@Component({
    standalone: false,
    selector: 'app-dynamic-page',
    templateUrl: './dynamic-page.component.html',
    styleUrls: ['./dynamic-page.component.scss']
})
export class DynamicPageComponent implements OnInit {
    @Input() static_page_type?: string

    paragraph_content = ''
    constructor(private route: ActivatedRoute) {}

    ngOnInit() {
        this.route.params.subscribe((params) => {
            const type = params['type']
            this.paragraph_content = dynamic_page_messages[type]
                ? 'error-messages.' + type
                : type
        })
    }
}
